import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import * as familiaApi from "../../api/familia";
import * as perfilApi from "../../api/perfil";
import { useAuth } from "../../auth/AuthContext";
import BuscarCrearFamiliaForm from "./BuscarCrearFamiliaForm";

/** Pantalla forzada la primera vez que un Cliente entra (mientras Usuarios.FamiliaDecisionTomada
 * sea false): crear/unirse a una familia, o decir que no quiere participar por ahora. Se pregunta
 * una sola vez -- después de elegir cualquiera de las opciones, se puede volver a decidir cuando
 * quiera desde "Mi Familia". */
export default function PrimerIngresoFamilia() {
  const { actualizarSesion } = useAuth();
  const [guardandoNoParticipar, setGuardandoNoParticipar] = useState(false);

  const resuelto = async () => {
    actualizarSesion(await perfilApi.refrescarToken());
  };

  const handleNoParticipar = async () => {
    setGuardandoNoParticipar(true);
    try {
      await familiaApi.noParticipar();
      await resuelto();
    } finally {
      setGuardandoNoParticipar(false);
    }
  };

  return (
    <div className="d-flex justify-content-center">
      <div className="fs-card" style={{ maxWidth: 520, width: "100%" }}>
        <h4 className="mb-1">¿A qué familia perteneces?</h4>
        <p className="text-muted small">
          FinanzasSys agrupa a las familias que usan "Familia Gastos" para repartir los gastos comunes.
          Esto solo se pregunta una vez -- si no decidís ahora, siempre podés volver a esto desde "Mi Familia".
        </p>
        <BuscarCrearFamiliaForm
          onResuelto={resuelto}
          accionExtra={
            <div className="mt-3">
              <Button variant="link" size="sm" className="text-decoration-none px-0" onClick={handleNoParticipar} disabled={guardandoNoParticipar}>
                {guardandoNoParticipar ? <Spinner size="sm" animation="border" /> : "No quiero pertenecer a ninguna familia por ahora"}
              </Button>
            </div>
          }
        />
      </div>
    </div>
  );
}
